import _ from "lodash";
import { graphql, compose } from "lib/apolloClient";

import withLoader from "UIComponents/GqlWithLoader";
import DualPanelManageMembers from "AppComponents/DualPanelManageMembers";
import { familyMembersFromStudentsQuery } from "MessagingV2/modules/MessagingQuery";
import { getOrganizationId } from "modules/CommonSelectors";
import { PARENT } from "Constants/stringConstants";
import { prepareLoadMoreFeed } from "Utils";

const getStudentIdsFromPreviousFamilyMembers = prevUsers => {
  const families = _.filter(prevUsers, { type: PARENT });
  const children = _.map(families, "children");
  const uniqueChildrenIds = _.reduce(
    children,
    (acc, children) => _.union(acc, _.map(children, "id")),
    []
  );
  return uniqueChildrenIds;
};

const DepartmentChannelQueryWrapper = compose(
  graphql(familyMembersFromStudentsQuery, {
    name: "familyMembersFromStudents",
    options: props => {
      const { prevUsers } = props;

      const studentIds = getStudentIdsFromPreviousFamilyMembers(prevUsers);

      return {
        fetchPolicy: "cache-and-network",
        variables: {
          organizationId: getOrganizationId(),
          portalType: "PLANNER",
          first: 10,
          filter: {
            students: studentIds,
            familyStatus: "ROSTERED",
          },
        },
      };
    },
    props: ({ familyMembersFromStudents }) => {
      const queryVariables = _.get(familyMembersFromStudents, "variables", {});

      const node = _.get(familyMembersFromStudents, "node", {});

      const familyMembersEdge = _.get(node, "familyMembers.edges", []);

      const hasNextPage = _.get(
        node,
        "familyMembers.pageInfo.hasNextPage",
        false
      );

      const membersParams = {
        userNodeList: familyMembersEdge,
        headerTitle: "common:family_member_plural",
        hasNextPage,
        networkStatus: familyMembersFromStudents["networkStatus"],
        isFetchingMore: _.includes(
          [3],
          familyMembersFromStudents["networkStatus"]
        ),

        loadMoreFeed: prepareLoadMoreFeed({
          query: familyMembersFromStudentsQuery,
          variables: {
            ...queryVariables,
            after: _.get(node, "familyMembers.pageInfo.endCursor"),
          },
          queryData: familyMembersFromStudents,
          key: "familyMembers",
        }),
      };

      return {
        isData: !_.isEmpty(node),
        isLoading: _.includes(
          [1, 2],
          familyMembersFromStudents["networkStatus"]
        ),
        membersParams,
      };
    },
  }),
  withLoader
)(DualPanelManageMembers.CohortList);

export const metadataProps = {
  emptyStateSubtitle: "common:no_family_members",
  countUsersSelectedText: "common:count_member_selected",
  selectedUsersListText: "common:selected_members_list",
  disabledUserTooltipText: "common:user_already_exists_in_channel",
  disabledNestedFamilyTooltipText:
    "common:family_member_already_exist_in_channel",
};

export default DepartmentChannelQueryWrapper;
